// import React, { useState } from "react";
import React, { useState, useEffect } from "react";
import { Header, TopBar } from "../../components/Header";
import { Footer } from "../../components/Footer";
import { ExtraLoaderModal, ProductModal } from "./Modal";
import { OrderApi } from "../../app/api/order.api";
import { useNavigate } from "react-router";


export function NewOrder() 
{
  const navigate = useNavigate();
  const orders = OrderApi();
  
  const [status, setStatus] = useState(0);
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false); 

  const [showDetail, setShowDetail] = useState(false);
  // const [showLoader, setShowLoader] = useState(false);
  const [showExtraLoader, setShowExtraLoader] = useState(false);

  const [state, setState] = useState(false);
  const [products, setProducts] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [checked, setChecked] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  

  useEffect(() => {
    const storedCart = JSON.parse(localStorage.getItem("cart")) || [];
    setProducts(storedCart);
    const total = storedCart.reduce(
      (sum, prod) => sum + (prod.product.price * prod.count),
      0
    );

    setTotalAmount(total);
    setState(storedCart.length > 0);
  }, []);
 
  const handleEdit = ( product ) => {
    setSelectedProduct( product );
    setShowDetail(true);
  };

  // const importCart = () => {
  //   setShowLoader(true);
  //   setState(false);

  //   setTimeout(() => {
  //     const storedCart = JSON.parse(localStorage.getItem("cart")) || []; 
  //     setProducts(storedCart);
  //     // Calculer le montant total
  //     const total = storedCart.reduce(
  //         (sum, prod) => sum + ( prod.product.price * prod.count ), 0
  //     );
  //     setTotalAmount(total);
  //     setShowLoader(false);
  //     setState(true);
  //   }, 1000); 
  // };

  // Supprimer un 
  const handleRemove = (productId) => {
    const updatedProducts = products.filter(
      (item) => item.product.id !== productId
    );

    setProducts(updatedProducts);
    // localStorage.setItem("cart", JSON.stringify(updatedProducts));

    const total = updatedProducts.reduce(
      (sum, prod) => sum + (prod.product.price * prod.count),
      0
    );

    setTotalAmount(total);
    setState(updatedProducts.length > 0);
  };

  
  // const handleRemove = (productId) => {
  //   const updatedProducts = products.filter((item) => item.product.id !== productId);
  //   setProducts(updatedProducts);

  //   // Recalcul du total
  //   const total = updatedProducts.reduce((sum, prod) => sum + ( prod.product.price * prod.count ), 0);
  //   setTotalAmount(total);

  //   if (updatedProducts.length === 0) setState(false);
  // };


  // Créer une commande
  const createOrder = async() => {
    
    const payload = {
      products: products.map(item => ({
        id: item.product.id,
        count: item.count
      }))
    };

    setStatus(0);
    setIsLoading(true);
    setShowExtraLoader(true);

    try {
        const {data} = await orders.insert(payload );
        if( data.success ){
            setStatus(1);
            setMessage(data.message);
            // Redirection après 4 secondes
            setTimeout(() =>{
              setShowExtraLoader(false);
              navigate("/commandes-en-cours");
            }, 4000);
        }
        else{
            setStatus(-1);
            setMessage('Erreur ! veuillez réessayer');
        }
    } catch (err) { 
        
        setStatus(-1);
        const response = err?.response?.data;

        if (response?.message) {
          setMessage(response.message);
        } else if (Array.isArray(response?.errors) && response.errors.length > 0) {
          setMessage(response.errors[0].message || response.errors[0]);
        } else {
          setMessage("Une erreur est survenue. Veuillez réessayer.");
        }       
    } finally{
        setIsLoading(false);
        // Redirection après 4 secondes
        setTimeout(() =>{
          setShowExtraLoader(false);
        }, 4000);
    }

  };


  return (
    <div className="container-fluid bg-light-gray">
      <div className="row">
        <TopBar />
      </div>
      <div className="row sticky-top">
        <Header page={6} />
      </div>

      <div className="row justify-content-center pt-4 pb-5 mb-3">
        <div className="col-lg-9 col-md-11">
          <div className="row mb-3 mt-4">
            <div className="border bg-white text-secondary rounded-top-3">
              <div className="d-flex justify-content-between flex-column flex-md-row align-items-center px-4 py-3 fs-5 gap-2">
                <span>
                  <i className="bi bi-receipt me-2"></i> Nouveau commande
                </span>
                {/* <div className="d-flex gap-3">
                  <button className="btn btn-outline-green px-3" onClick={importCart}>
                    <i className="bi bi-upload ms-1"></i> Importer panier
                  </button>
                </div> */}
              </div>
            </div>
          </div>

          {/* Montant Commande */}
          {state && (
            <div className="row mb-2">
              <div className="bg-white rounded-3 mb-4 px-4 py-3 border">

                <div className="d-flex align-items-center">
                  <span className="border text-secondary py-2 px-3 bg-light fw-bold border-end">
                    <i className="bi bi-grid-fill me-2"></i> Montant total :
                  </span>
                  <span className="border text-secondary fw-bold py-2 px-3">
                    {totalAmount.toLocaleString()}
                  </span>
                  <span className="border text-secondary py-2 px-3 bg-light border-start"> FCFA </span>
                </div>

                <div className="d-flex flex-column mt-4 gap-3">
                  <div className="d-flex align-items-center gap-2">
                    <input type="checkbox" name="name" checked={checked} onChange={(e) => setChecked(e.target.checked)} style={{ width: '18px', height: '18px' }} />
                    <span className="small text-secondary"> Souhaitez-vous valider cette commande </span>
                  </div>
                  <div className="d-flex">
                    <button className="btn btn-green px-3 rounded-0" disabled={!checked} onClick={ createOrder }>
                      Envoyer la commande <i className="bi bi-chevron-right ms-1"></i>
                    </button>
                  </div>
                </div>

              </div>
            </div>
          )}

          {/* Produits Commandés */}
          <div className="row border bg-white text-secondary rounded-3 p-3 mb-4">
            {!state && (
              <div className="d-flex flex-column gap-2 justify-content-center align-items-center p-3 border">
                <i className="bi bi-folder-x lead fs-1"></i>
                <span className="lead text-dark"> Commande vide </span>
              </div>
            )}

            {state && (
              <div className="d-fex text-secondary py-3">
              {
                products.map((item, index) => (
                  <div key={index} className="border d-flex flex-column flex-lg-row gap-3 mb-3 ps-3" >
                    <div className="product-image p-3 bg-light">
                      <img src={ item.product.images[0].url } className="img-fluid-custom" alt={ item.product.name } />
                    </div>
                    <div className="product-info border-start p-3 w-100">
                      <div className="d-flex justify-content-between w-100 mb-2">
                        <span className="text-secondary fw-bold">
                          { item.product.name }
                        </span>
                        <div className="d-flex gap-3">
                          <button className="btn btn-sm btn-outline-green" onClick={() => handleEdit( item.product )}>
                            <i className="bi bi-box-arrow-up-right"></i>
                          </button>
                          <button className="btn btn-sm btn-outline-danger" onClick={() => handleRemove( item.product.id )}>
                            <i className="bi bi-trash"></i>
                          </button>
                        </div>
                      </div>
                      <div className="d-flex justify-content-between w-100">
                        <span className="label">Prix unitaire :</span>
                        <span className="value">
                          { item.product.price + " " + item.product.currency }
                        </span>
                      </div>
                      <div className="d-flex justify-content-between w-100 pb-2 border-bottom">
                        <span className="label">Quantité</span>
                        <span className="value">{ item.count }</span>
                      </div>
                      <div className="d-flex justify-content-between w-100 mt-2">
                        <span className="text-dark">Prix total</span>
                        <span className="h5 text-dark">
                          { item.product.price * item.count } FCFA
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="row">
        <Footer />
      </div>



      {/* Loader */}
      {/* <LoaderModal show={showLoader} onHide={() => setShowLoader(false)} />  */}
     
      {/* Extra Loader */}
      <ExtraLoaderModal show={showExtraLoader} onHide={() => setShowExtraLoader(false)} isLoading={isLoading} response={message} status={status} /> 
     
      {/* Modal de previsualisation */}
      {
         selectedProduct && ( <ProductModal show={showDetail} onHide={() => setShowDetail(false)} product={selectedProduct} /> )
      }
      
    </div>
  );
}
